import { render } from "./AccordionShell.vue?vue&type=template&id=cd625cea"
import script from "./AccordionShell.vue?vue&type=script&lang=js"
export * from "./AccordionShell.vue?vue&type=script&lang=js"

import "./AccordionShell.vue?vue&type=style&index=0&id=cd625cea&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__